<!--
  --
  -- 支払方法選択ページ
  --
  -->
<template>
  <c-container form wide>
    <c-book-header>支払方法を選択</c-book-header>

    <c-book-summary-sheet/>

    <c-form card-style
      @submit="onSubmit"
    >
      <v-card-text>
        <c-no-payment-sheet
          v-if="payments.length === 0"
        />

        <c-payment-sheet
          v-else
          v-model="payID"
          :payments="payments"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer/>

        <v-btn text outlined class="mr-4" color="primary" :to="{name: 'my/newcard'}">
          支払方法を追加
        </v-btn>

        <v-btn
          color="primary" type="submit"
          :loading="running"
          :disabled="!valid || running"
        >
          次へ
        </v-btn>
      </v-card-actions>

    </c-form>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CBookHeader from '@/pages/book/components/CBookHeader'
import CBookSummarySheet from '@/pages/book/components/CBookSummarySheet'
import CForm from '@/components/CForm'
import CPaymentSheet from './CPaymentSheet'
import CNoPaymentSheet from './CNoPaymentSheet'

import * as api from '@/api'
import { same } from '@/libs/a'
import { Route } from '@/libs/component'
import * as C from '@/consts'

const ROUTE_NEXT = { name: 'book/confirm' }

export default {
  name: 'Payment',
  mixins: [
    page('支払方法')
  ],
  components: {
    CBookHeader,
    CBookSummarySheet,
    CForm,
    CPaymentSheet,
    CNoPaymentSheet
  },

  async prepare (to, from, store) {
    // org.traits からサポートする支払方法を取得する
    const paymentMethods = store.getters['org/paymentMethods']

    // 現地支払のみのサポートなら、このページをスキップする
    if (same(paymentMethods, [C.PAY_SPOT])) {
      store.commit('book/setPay', {
        payID: C.PAYID_SPOT,
        type: C.PAYTYPE_SPOT,
        method: C.PAY_SPOT
      })
      return new Route(ROUTE_NEXT)
    }

    // すでに選択した支払方法を取得する
    const pay = store.getters['book/pay']

    // ユーザが登録している支払方法を取得する
    const userID = store.getters['user/id']
    const resp = await api.getUserPayments(userID)
    const pays = resp.data.payments

    // 選択した車両情報を取得
    const car = store.getters['book/car']

    // 支払方法一覧を取得する
    const payments = []
    paymentMethods.forEach(method => {
      let payType
      if (method === C.PAY_SPOT) {
        payType = C.PAYTYPE_SPOT
      } else if (method === C.PAY_CARD_AUTH || method === C.PAY_CARD_CAPTURE) {
        payType = C.PAYTYPE_CARD
      }

      if (!payType) {
        return
      }

      if (payType === C.PAY_SPOT && car.attributes.keykey !== 1 && car.attributes.vkey !== 1) {
        // 現地支払の支払方法を payments に追加
        payments.push({
          payID: C.PAYID_SPOT,
          type: C.PAYTYPE_SPOT,
          method: C.PAY_SPOT
        })
      }

      // 支払タイプが一致したもののみ payments に追加
      for (let i = 0, len = pays.length; i < len; ++i) {
        if (pays[i].type === payType) {
          payments.push({ ...pays[i], method })
        }
      }
    })

    // 選択する payID を決定する
    let payID

    // payments に pay.payID があれば、それを選択する
    if (pay && payments.findIndex(item => item.payID === pay.payID) >= 0) {
      payID = pay.payID
    }

    if (payID === undefined) {
      // 最初のデフォルトの支払方法を取得する
      const defaultPay = payments.find(item => item.defaultFlg)

      if (defaultPay) {
        // デフォルトが見つかった
        payID = defaultPay.payID
      } else if (payments.length > 0) {
        // 先頭を選択する
        payID = payments[0].payID
      }
    }

    return { payments, payID }
  },

  props: {
    payments: Array,
    payID: Number
  },

  data () {
    return {
      // フォームのバリデーション状態
      valid: (this.payID !== undefined),

      // 処理中
      running: false
    }
  },

  methods: {
    onSubmit () {
      // book ストアに pay を保存する
      const pay = this.payments.find(item => item.payID === this.payID)
      this.commit('book/setPay', pay)

      // 次のページへ
      this.goTo(ROUTE_NEXT)
    }
  }
}
</script>
